import Marquee from "react-fast-marquee";
import HeroSection from "@/components/home/HeroSection";
import BentoServices from "@/components/home/BentoServices";
import ProductsShowcase from "@/components/home/ProductsShowcase";
import StatsBand from "@/components/home/StatsBand";
import ProcessTimeline from "@/components/home/ProcessTimeline";
import CaseStudySpotlight from "@/components/home/CaseStudySpotlight";
import TestimonialsCarousel from "@/components/home/TestimonialsCarousel";
import FinalCTA from "@/components/home/FinalCTA";
import { TRUSTED_BY, TECH_STACK } from "@/data/content";
import { LogoCloud } from "@/components/ui/logo-cloud-2";

export default function Home() {
  return (
    <div data-testid="home-page">
      <HeroSection />

      {/* CLIENT LOGO GRID */}
      <section className="py-16 md:py-24 bg-white border-y border-slate-100 overflow-hidden" data-testid="trusted-by-section">
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <p className="font-mono-brand text-center text-[11px] font-semibold tracking-[0.25em] uppercase text-slate-400 mb-10">
            Trusted by teams building the future
          </p>
          <LogoCloud />
        </div>
      </section>

      <BentoServices />
      <ProductsShowcase />
      <StatsBand />
      <ProcessTimeline />
      <CaseStudySpotlight />
      <TestimonialsCarousel />

      {/* TECH STACK MARQUEE — reverse direction, quiet */}
      <section className="py-9 border-y border-slate-100 bg-white" data-testid="tech-marquee-section">
        <Marquee speed={26} direction="right" gradient gradientColor="#ffffff" gradientWidth={80} autoFill>
          {TECH_STACK.map((tech) => (
            <span key={tech} className="font-mono-brand mx-7 text-sm text-slate-400 hover:text-[#2563EB] transition-colors cursor-default">
              {tech}
            </span>
          ))}
        </Marquee>
      </section>

      <FinalCTA />
    </div>
  );
}
